import { filter, find, findIndex } from 'lodash';
import { observable, action, makeObservable } from 'mobx'
import IVariable from '../interfaces/IVariable';

export default class VariableStore {

     list: IVariable[] = [];

    
    addRecords(records: IVariable[]): any {
        if (records.length > 0) {
            records.forEach((record: IVariable) => this.addRecord(record));
        }
    }

    
    private addRecord(record: IVariable) {
        if (!record) {
            return;
        }

        const index = findIndex(this.list, { id: record.id });
        if (index >= 0) {
            this.list.splice.apply(this.list, [index, 1, record]);
        } else {
            this.list.push(record);
        }
    }

    public getById(id: string): IVariable {
        return find(this.list, { id: id });
    }

    public getByIds(ids: string[]): IVariable[] {
        return filter(this.list, item => {
            if (ids.includes(item.id)) {
                return true;
            }
            return false;
        })
    }

    public getByUserId(userId: string): IVariable[] {
        return filter(this.list, { userId: userId });
    }

    public getByWebsiteId(websiteId: string): IVariable[] {
        return filter(this.list, { websiteId: websiteId });
    }

    public removeById(id: string) {
        this.list = filter(this.list, item => {
            if (item.id != id) {
                return true;
            }
            return false;
        })
    }

    constructor() {
        makeObservable(this, {
            list: observable,
            addRecords: action,
            removeById: action,
        })
    }
}